const yearsList = () => {
  const list = [
    {
      label: "年",
      value: "",
    },
  ];
  let currentYear = new Date().getFullYear();
  let earliestYear = 1950;

  while (currentYear >= earliestYear) {
    list.push({
      label: currentYear,
      value: currentYear,
    });
    currentYear -= 1;
  }

  return list;
};

const monthsList = [
  {
    label: "月",
    value: "",
  },
  {
    label: "1",
    value: "1",
  },
  {
    label: "2",
    value: "2",
  },
  {
    label: "3",
    value: "3",
  },
  {
    label: "4",
    value: "4",
  },
  {
    label: "5",
    value: "5",
  },
  {
    label: "6",
    value: "6",
  },
  {
    label: "7",
    value: "7",
  },
  {
    label: "8",
    value: "8",
  },
  {
    label: "9",
    value: "9",
  },
  {
    label: "10",
    value: "10",
  },
  {
    label: "11",
    value: "11",
  },
  {
    label: "12",
    value: "12",
  },
];

const daysList = () => {
  const list = [
    {
      label: "日",
      value: "",
    },
  ];
  let end = 31;
  let start = 1;

  while (start <= end) {
    list.push({
      label: start,
      value: start,
    });
    start += 1;
  }

  return list;
};

const genderList = [
  {
    label: "先生",
    value: "先生",
  },
  {
    label: "小姐",
    value: "小姐",
  },
];

export { yearsList, monthsList, daysList, genderList };
